import axios from "axios";

export function getEventTypeList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "EventsType/getlist", config);
}

export function postEventType(data) {
  return axios.post(process.env.VUE_APP_API_URL + "EventsType/add", data);
}

export function updateEventType(data) {
  return axios.put(process.env.VUE_APP_API_URL + "EventsType/update", data);
}

export function deleteEventType(eventsTypeId) {
  const config = {
    params: {
      eventsTypeId: eventsTypeId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "EventsType/deleted",
    config
  );
}
